
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexEQ2xUCxx6PfIrbkrZmQkoygyfNXJ7HF_SHEzKJ2OulYMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/index/index.vue?macro=true";
import { default as indexTuGnFI1VDnQD3wtQ_xRgrhqFQMP53uQvuBuDa455Ge0Meta } from "/var/jenkins_home/workspace/pdf_one_web/pages/editor/index.vue?macro=true";
import { default as index1_VxfoC5yywNRXAcdTg7h3B6dcumZ_h7ApXgm6uwmVacMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/editor/index1.vue?macro=true";
import { default as indexcdzuoHxNv6hhFqy3_nCWq00WpU_45xQTIuJsZBt9zA0YMMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/reviews/index.vue?macro=true";
import { default as index6GZU3y7CGlj_ec8yOhNNtvP7Kd_6X8eVa6N5R_0fl4IMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/contactUs/index.vue?macro=true";
import { default as index6Fp_qfwLNXMl_jLUzwzH99ClzQU7uF6eW_45Bw_45Ta8WtYMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/index.vue?macro=true";
import { default as index6AkqAGV7Fbhyx6Jdyuv9f85oeiQ2KpNtfDi89hkbrZcMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/index.vue?macro=true";
import { default as menuHome79CFGO2NYzc8Ld6H2NEMQa96GDrrYGa0SCn83xYAd_MMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/menuHome.vue?macro=true";
import { default as _91_46_46_46slug_93ZJ9U0mkDrKRBQ8QqGpQV7b9fpVR76uKGUkiKLG5_458DQMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/[...slug].vue?macro=true";
import { default as disclaimersEn1icFyqNfTjhSTkx_EZYg_PU4dPb_r3K6nJRTHDnE9XcMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersEn.vue?macro=true";
import { default as disclaimersJauch6acQOjX9ywvqPlW5nF5iwLsnNyxU_458bEiGzzui7cMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersJa.vue?macro=true";
import { default as disclaimersZhNZpC9htYn_R8Nj7gi7KPzHNSUX_45b4sPZZc_4582_455_45SLMMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersZh.vue?macro=true";
import { default as cookiePolicyEnH5mnCh9NhsCSMl4oh5_45Zp8ZcFsBP8sXLfruhLK7zaOMMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyEn.vue?macro=true";
import { default as cookiePolicyJanyv9oPMi3hT1IvyAwyEnLOOpM_7TPYAZedPxR_45AbllQMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyJa.vue?macro=true";
import { default as cookiePolicyZhOPoKGXjy92t7MD4TeMf0NcanHOOls3f8AUMTIIUbTtUMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyZh.vue?macro=true";
import { default as termsServiceEnpoQpddteU5NywKP5o2lC2A1Mtt5RJ0EBZ2_452xUsjihgMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceEn.vue?macro=true";
import { default as termsServiceJa2hECvEda1WXol1In9cffAafLWQShx5Ft_455qcwtQLMn4Meta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceJa.vue?macro=true";
import { default as termsServiceZhijJUJuPRtEt9Lj4T7eDvmb6luRDgb1v2VxvsNwzRHZUMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceZh.vue?macro=true";
import { default as PrivacyPolicyEnfKTrZH_IU0TtanDfI04dUd83yUnYGLWzRj0D_45aJKoDkMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyEn.vue?macro=true";
import { default as PrivacyPolicyJawC6p83NhiFnCAXzGrT1HvnI_45ZMXDiAgdZHLA0nDF0KwMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyJa.vue?macro=true";
import { default as PrivacyPolicyZhtv3bpHTF1b1ghI8Qba3R8RIUdqHLvpUpL5kyKhSTdmQMeta } from "/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyZh.vue?macro=true";
import { default as component_45stub8ph5bhqDnUm0WFYizRKXaFFaHFmAeIW7AI0g5xS9VFMMeta } from "/var/jenkins_home/workspace/pdf_one_web/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub8ph5bhqDnUm0WFYizRKXaFFaHFmAeIW7AI0g5xS9VFM } from "/var/jenkins_home/workspace/pdf_one_web/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/index/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/index/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/index/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/index/index.vue")
  },
  {
    name: "editor___en",
    path: "/en/editor",
    meta: indexTuGnFI1VDnQD3wtQ_xRgrhqFQMP53uQvuBuDa455Ge0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/editor/index.vue")
  },
  {
    name: "editor___zh",
    path: "/zh/editor",
    meta: indexTuGnFI1VDnQD3wtQ_xRgrhqFQMP53uQvuBuDa455Ge0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/editor/index.vue")
  },
  {
    name: "editor___ja",
    path: "/ja/editor",
    meta: indexTuGnFI1VDnQD3wtQ_xRgrhqFQMP53uQvuBuDa455Ge0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/editor/index.vue")
  },
  {
    name: "editor-index1___en",
    path: "/en/editor/index1",
    meta: index1_VxfoC5yywNRXAcdTg7h3B6dcumZ_h7ApXgm6uwmVacMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/editor/index1.vue")
  },
  {
    name: "editor-index1___zh",
    path: "/zh/editor/index1",
    meta: index1_VxfoC5yywNRXAcdTg7h3B6dcumZ_h7ApXgm6uwmVacMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/editor/index1.vue")
  },
  {
    name: "editor-index1___ja",
    path: "/ja/editor/index1",
    meta: index1_VxfoC5yywNRXAcdTg7h3B6dcumZ_h7ApXgm6uwmVacMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/editor/index1.vue")
  },
  {
    name: "reviews___en",
    path: "/en/reviews",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/reviews/index.vue")
  },
  {
    name: "reviews___zh",
    path: "/zh/reviews",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/reviews/index.vue")
  },
  {
    name: "reviews___ja",
    path: "/ja/reviews",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/reviews/index.vue")
  },
  {
    name: "contactUs___en",
    path: "/en/contactUs",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/contactUs/index.vue")
  },
  {
    name: "contactUs___zh",
    path: "/zh/contactUs",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/contactUs/index.vue")
  },
  {
    name: "contactUs___ja",
    path: "/ja/contactUs",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/contactUs/index.vue")
  },
  {
    name: "serviceDocs___en",
    path: "/en/serviceDocs",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/index.vue")
  },
  {
    name: "serviceDocs___zh",
    path: "/zh/serviceDocs",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/index.vue")
  },
  {
    name: "serviceDocs___ja",
    path: "/ja/serviceDocs",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/index.vue")
  },
  {
    name: "tutorialConsultation___en",
    path: "/en/tutorialConsultation",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/index.vue")
  },
  {
    name: "tutorialConsultation___zh",
    path: "/zh/tutorialConsultation",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/index.vue")
  },
  {
    name: "tutorialConsultation___ja",
    path: "/ja/tutorialConsultation",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/index.vue")
  },
  {
    name: "tutorialConsultation-menuHome___en",
    path: "/en/tutorialConsultation/menuHome",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/menuHome.vue")
  },
  {
    name: "tutorialConsultation-menuHome___zh",
    path: "/zh/tutorialConsultation/menuHome",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/menuHome.vue")
  },
  {
    name: "tutorialConsultation-menuHome___ja",
    path: "/ja/tutorialConsultation/menuHome",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/menuHome.vue")
  },
  {
    name: "blog-slug___en",
    path: "/en/tutorialConsultation/:slug(.*)*",
    meta: _91_46_46_46slug_93ZJ9U0mkDrKRBQ8QqGpQV7b9fpVR76uKGUkiKLG5_458DQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/[...slug].vue")
  },
  {
    name: "blog-slug___zh",
    path: "/zh/tutorialConsultation/:slug(.*)*",
    meta: _91_46_46_46slug_93ZJ9U0mkDrKRBQ8QqGpQV7b9fpVR76uKGUkiKLG5_458DQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/[...slug].vue")
  },
  {
    name: "blog-slug___ja",
    path: "/ja/tutorialConsultation/:slug(.*)*",
    meta: _91_46_46_46slug_93ZJ9U0mkDrKRBQ8QqGpQV7b9fpVR76uKGUkiKLG5_458DQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/tutorialConsultation/[...slug].vue")
  },
  {
    name: "serviceDocs-components-disclaimersEn___en",
    path: "/en/serviceDocs/components/disclaimersEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersEn.vue")
  },
  {
    name: "serviceDocs-components-disclaimersEn___zh",
    path: "/zh/serviceDocs/components/disclaimersEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersEn.vue")
  },
  {
    name: "serviceDocs-components-disclaimersEn___ja",
    path: "/ja/serviceDocs/components/disclaimersEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersEn.vue")
  },
  {
    name: "serviceDocs-components-disclaimersJa___en",
    path: "/en/serviceDocs/components/disclaimersJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersJa.vue")
  },
  {
    name: "serviceDocs-components-disclaimersJa___zh",
    path: "/zh/serviceDocs/components/disclaimersJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersJa.vue")
  },
  {
    name: "serviceDocs-components-disclaimersJa___ja",
    path: "/ja/serviceDocs/components/disclaimersJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersJa.vue")
  },
  {
    name: "serviceDocs-components-disclaimersZh___en",
    path: "/en/serviceDocs/components/disclaimersZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersZh.vue")
  },
  {
    name: "serviceDocs-components-disclaimersZh___zh",
    path: "/zh/serviceDocs/components/disclaimersZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersZh.vue")
  },
  {
    name: "serviceDocs-components-disclaimersZh___ja",
    path: "/ja/serviceDocs/components/disclaimersZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/disclaimersZh.vue")
  },
  {
    name: "serviceDocs-components-cookiePolicyEn___en",
    path: "/en/serviceDocs/components/cookiePolicyEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyEn.vue")
  },
  {
    name: "serviceDocs-components-cookiePolicyEn___zh",
    path: "/zh/serviceDocs/components/cookiePolicyEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyEn.vue")
  },
  {
    name: "serviceDocs-components-cookiePolicyEn___ja",
    path: "/ja/serviceDocs/components/cookiePolicyEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyEn.vue")
  },
  {
    name: "serviceDocs-components-cookiePolicyJa___en",
    path: "/en/serviceDocs/components/cookiePolicyJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyJa.vue")
  },
  {
    name: "serviceDocs-components-cookiePolicyJa___zh",
    path: "/zh/serviceDocs/components/cookiePolicyJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyJa.vue")
  },
  {
    name: "serviceDocs-components-cookiePolicyJa___ja",
    path: "/ja/serviceDocs/components/cookiePolicyJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyJa.vue")
  },
  {
    name: "serviceDocs-components-cookiePolicyZh___en",
    path: "/en/serviceDocs/components/cookiePolicyZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyZh.vue")
  },
  {
    name: "serviceDocs-components-cookiePolicyZh___zh",
    path: "/zh/serviceDocs/components/cookiePolicyZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyZh.vue")
  },
  {
    name: "serviceDocs-components-cookiePolicyZh___ja",
    path: "/ja/serviceDocs/components/cookiePolicyZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/cookiePolicyZh.vue")
  },
  {
    name: "serviceDocs-components-termsServiceEn___en",
    path: "/en/serviceDocs/components/termsServiceEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceEn.vue")
  },
  {
    name: "serviceDocs-components-termsServiceEn___zh",
    path: "/zh/serviceDocs/components/termsServiceEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceEn.vue")
  },
  {
    name: "serviceDocs-components-termsServiceEn___ja",
    path: "/ja/serviceDocs/components/termsServiceEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceEn.vue")
  },
  {
    name: "serviceDocs-components-termsServiceJa___en",
    path: "/en/serviceDocs/components/termsServiceJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceJa.vue")
  },
  {
    name: "serviceDocs-components-termsServiceJa___zh",
    path: "/zh/serviceDocs/components/termsServiceJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceJa.vue")
  },
  {
    name: "serviceDocs-components-termsServiceJa___ja",
    path: "/ja/serviceDocs/components/termsServiceJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceJa.vue")
  },
  {
    name: "serviceDocs-components-termsServiceZh___en",
    path: "/en/serviceDocs/components/termsServiceZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceZh.vue")
  },
  {
    name: "serviceDocs-components-termsServiceZh___zh",
    path: "/zh/serviceDocs/components/termsServiceZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceZh.vue")
  },
  {
    name: "serviceDocs-components-termsServiceZh___ja",
    path: "/ja/serviceDocs/components/termsServiceZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/termsServiceZh.vue")
  },
  {
    name: "serviceDocs-components-PrivacyPolicyEn___en",
    path: "/en/serviceDocs/components/PrivacyPolicyEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyEn.vue")
  },
  {
    name: "serviceDocs-components-PrivacyPolicyEn___zh",
    path: "/zh/serviceDocs/components/PrivacyPolicyEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyEn.vue")
  },
  {
    name: "serviceDocs-components-PrivacyPolicyEn___ja",
    path: "/ja/serviceDocs/components/PrivacyPolicyEn",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyEn.vue")
  },
  {
    name: "serviceDocs-components-PrivacyPolicyJa___en",
    path: "/en/serviceDocs/components/PrivacyPolicyJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyJa.vue")
  },
  {
    name: "serviceDocs-components-PrivacyPolicyJa___zh",
    path: "/zh/serviceDocs/components/PrivacyPolicyJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyJa.vue")
  },
  {
    name: "serviceDocs-components-PrivacyPolicyJa___ja",
    path: "/ja/serviceDocs/components/PrivacyPolicyJa",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyJa.vue")
  },
  {
    name: "serviceDocs-components-PrivacyPolicyZh___en",
    path: "/en/serviceDocs/components/PrivacyPolicyZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyZh.vue")
  },
  {
    name: "serviceDocs-components-PrivacyPolicyZh___zh",
    path: "/zh/serviceDocs/components/PrivacyPolicyZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyZh.vue")
  },
  {
    name: "serviceDocs-components-PrivacyPolicyZh___ja",
    path: "/ja/serviceDocs/components/PrivacyPolicyZh",
    component: () => import("/var/jenkins_home/workspace/pdf_one_web/pages/serviceDocs/components/PrivacyPolicyZh.vue")
  },
  {
    name: component_45stub8ph5bhqDnUm0WFYizRKXaFFaHFmAeIW7AI0g5xS9VFMMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub8ph5bhqDnUm0WFYizRKXaFFaHFmAeIW7AI0g5xS9VFM
  }
]